export enum ContactType {
  Email = 'email',
  Phone = 'phone',
  Mobile = 'mobile',
}
